import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { COMPANY, NAV_LINKS } from "../../data/site";

const SERVICE_LINKS = [
  "Detailed Commercial Cleaning",
  "Floor & Surface Care",
  "Facility Maintenance",
  "Post-Construction Cleaning",
  "Window & Glass Cleaning",
  "Customized Cleaning Plans",
];

const LEGAL = [
  { label: "Privacy Policy", path: "/privacy" },
  { label: "Terms", path: "/terms" },
  { label: "Accessibility", path: "/accessibility" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-navy text-white">
    <div className="container-px mx-auto max-w-[1500px] py-20">
      <div className="grid gap-14 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <div className="flex items-center">
            <span className="inline-flex bg-white px-3 py-2">
              <img src="/pm1-logo.png" alt="PM1 Clean — Precision Maintenance1 LLC" className="h-8 w-auto" width="640" height="201" />
            </span>
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/60">
            {COMPANY.tagline}. An established commercial cleaning and facility-maintenance company serving corporate,
            automotive, retail, institutional and construction environments.
          </p>
          <Link to="/request-a-quote" data-testid="footer-quote-cta" className="btn-primary mt-8">
            Request a Customized Cleaning Plan
            <ArrowUpRight size={16} />
          </Link>
        </div>

        <FooterCol title="Navigation">
          {NAV_LINKS.map((l) => (
            <FooterLink key={l.path} to={l.path}>
              {l.label}
            </FooterLink>
          ))}
        </FooterCol>

        <FooterCol title="Services">
          {SERVICE_LINKS.map((s) => (
            <FooterLink key={s} to="/services">
              {s}
            </FooterLink>
          ))}
        </FooterCol>

        <FooterCol title="Contact">
          <a href={COMPANY.phoneHref} className="text-sm text-white/60 transition-colors hover:text-white">{COMPANY.phone}</a>
          <a href={COMPANY.emailHref} className="break-all text-sm text-white/60 transition-colors hover:text-white">{COMPANY.email}</a>
          <a href={COMPANY.websiteHref} target="_blank" rel="noopener noreferrer" className="text-sm text-white/60 transition-colors hover:text-white">{COMPANY.website}</a>
          <p className="text-sm text-white/50">{COMPANY.address}</p>
          <Link to="/contact" data-testid="footer-contact-link" className="link-underline mt-2 inline-block text-sm font-medium text-white">
            Talk With Our Team
          </Link>
        </FooterCol>
      </div>

      <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between">
        <p>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</p>
        <div className="flex flex-wrap gap-6">
          {LEGAL.map((l) => (
            <Link key={l.path} to={l.path} data-testid={`footer-legal-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="uppercase tracking-wider transition-colors hover:text-white">
              {l.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  </footer>
);

const FooterCol = ({ title, children }) => (
  <div>
    <h4 className="overline mb-5 text-white/50">{title}</h4>
    <div className="flex flex-col gap-3">{children}</div>
  </div>
);

const FooterLink = ({ to, children }) => (
  <Link to={to} className="w-fit text-sm text-white/60 transition-colors duration-200 hover:text-white">
    {children}
  </Link>
);
